"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/app/hooks";
import { Loading } from "@/app/components/ui";

export function withAuth(WrappedComponent: React.ComponentType<any>) {
   return function AuthenticatedComponent(props: any) {
      const router = useRouter();
      const { user, isLoggedIn, isInitializing } = useAuth();

      useEffect(() => {
         const isNotPass = !isInitializing && !isLoggedIn;
         if (isNotPass) {
            const locale = window.location.pathname.split("/")[1] || "vi";
            router.replace(`/${locale}/auth/login`);
         }
      }, [isInitializing, isLoggedIn, user, router]);

      if (isInitializing) {
         return (
            <div className="fixed inset-0 bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
               <Loading size="lg" />
            </div>
         );
      }

      if (!isLoggedIn || !user) {
         return null;
      }

      return <WrappedComponent {...props} />;
   };
}
